export const career = {
	lookingFor: {
		title: 'Koho hľadáme',
		content:
			'Do nášho kolektívu hľadáme samostatne tvoriaceho kolegu, ktorý má technické myslenie a príjemné ' +
			'vystupovanie. Autorizácia nie je podmienkou. Ak spĺňaš predpoklady, tak nám napíš na pareli@pareli.sk ' +
			'a viac si môžeme povedať na osobnom pohovore.',
	},
	activities: {
		title: 'Naše aktivity',
		content:
			'Sme si vedomí, že projekčná činnosť je náročná aktivita a sú chvíle kedy treba „jednoducho vypnúť“. ' +
			'Preto každý náš kolega v prípade záujmu sa môže stať držiteľom MultiSport karty. Okrem toho organizujeme ' +
			'futbalové zápasy, paintball stretnutia, firemné pobyty a večere.',
	},
};
